// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3lzvR","heading":"index-module--heading--sEZOZ","divider":"index-module--divider--oZDYp"};